import type { FC, Ref } from "react";

import {
  RadioButtons,
  type RadioButtonsProps,
} from "../../../components/RadioButtons";
import { Spacing } from "../../../components";

export type RadioButtonsProxyProps = Omit<
  RadioButtonsProps,
  "value" | "onChange" | "options"
> & {
  value?: string;
  onChange?: (value: string) => void;
  options?: {
    label: string;
    value: string;
  }[];
  /**
   * Ref forwarded to the root element
   */
  ref?: Ref<HTMLDivElement>;
};

export const RadioButtonsProxy: FC<RadioButtonsProxyProps> = ({
  value,
  options,
  ref,
  ...props
}) => (
  <>
    <Spacing />
    <RadioButtons value={value} options={options ?? []} {...props} ref={ref} />
    <Spacing />
  </>
);
